import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { infoUser, saveChanges } from "api/users";

export const fetchUserInfo = createAsyncThunk('user/fetchUserInfo', async () => {
  const response = await infoUser();
  return response.data;
});

export const updateUserInfo = createAsyncThunk('user/updateUserInfo', async (userData) => {
  const response = await saveChanges(userData.data, userData.id);
  return response.data;
});

const updateUserData = (state, userInfo) => {
  state.status = 'succeeded';
  const defaultValues = {
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    shipping_address: {},
    billing_address: {},
    pickUpLibrary: null,
    // asociatedLibraryImage: '',  
    assigned_library:{},
    isWorker: false,
    benefited_bookstore: {},
    date_birth: '',
    dni: '',
    phone_number: '',
    info_concourse: {},
    profile:''
  };
  userInfo = userInfo || {};
  Object.keys(defaultValues).forEach(key => {
    if (key === 'info_concourse') {
      state[key] = userInfo[key] !== undefined && userInfo[key] !== null ? userInfo[key] : defaultValues[key];
      return;
    }
    const stateKey = key.replace(/_([a-z])/g, g => g[1].toUpperCase());
    state[stateKey] = userInfo[key] !== undefined && userInfo[key] !== null ? userInfo[key] : defaultValues[key];
    if(key === 'benefited_bookstore') {
      state[stateKey] = { 
        value: userInfo[key]?.value || '',
        label: userInfo[key]?.label || '',
        subtitle: userInfo[key]?.subtitle || '',
        url: userInfo[key]?.url || '',
      };      
    }
    if (key === 'isWorker') {
      state[stateKey] = userInfo['type_user'] === 'trabajador';
    }
  });
};

export const initialState = {
  id:'',
  isLogged: false,
  shippingAddress: {
    address: '',
    postal_code: '',
    first_name: '',
    last_name: '',
    locality: '',
    province: '',
    country: '',
    email: '',
    phone: '',
  },
  billingAddress: {
    address: '',
    postal_code: '',
    first_name: '',
    last_name: '',
    locality: '',
    province: '',
    country: '',
    email: '',
    phone: '',
  },
  pickUpLibrary: null,
  // asociatedLibraryImage: '',
  assigned_library:{},
  firstName: '',
  lastName: '',
  email: '',
  isWorker: false,
  benefitedBookstore: {},
  dateBirth: '',
  dni: '',
  phoneNumber: '',
  status: 'idle',
  error: null,
  info_concourse: {},
  profile:''
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state) => {
      state.isLogged = true;
    },
    logoutSuccess: (state) => {
      state.isLogged = false;
      state.id = null;
    },
    setId: (state, action) => {
      state.id = action.payload;
    },
    setShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
    },
    setBillingAddress: (state, action) => {
      state.billingAddress = action.payload;
    },
    setPickUpLibrary: (state, action) => {
      state.pickUpLibrary = action.payload;
    },
    // setAsociatedLibraryImage: (state, action) => {
    //   state.asociatedLibraryImage = action.payload;
    // },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setIsWorker: (state, action) => {
      state.isWorker = action.payload;
    },
    setBenefitedBookstore: (state, action) => {
      state.benefitedBookstore = action.payload;
    },
    setAsignedLibrary: (state, action) => {
      state.assigned_library = action.payload;
    },
    setDateBirth: (state, action) => {
      state.dateBirth = action.payload;
    },
    setDni: (state, action) => {
      state.dni = action.payload;
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        updateUserData(state, action.payload);
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateUserInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateUserInfo.fulfilled, (state, action) => {
        updateUserData(state, action.payload);
      })
      .addCase(updateUserInfo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const {
  loginSuccess,
  logoutSuccess,
  setId,
  setShippingAddress,
  // setAsociatedLibraryImage,
  setAsignedLibrary,
  setFirstName,
  setLastName,
  setEmail,
  setIsWorker,
  setBenefitedBookstore,
  setBillingAddress,
  setPickUpLibrary,
  setDateBirth,
  setDni,
  setPhoneNumber
} = userSlice.actions;
export const userSelector = (state) => state.user;
export default userSlice.reducer;